import React, { useState } from 'react';
import {
  Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { C, Section, SectionLabel } from './theme';

const faqs = [
  {
    q: 'Are these backlinks safe for Google / will I get penalized?',
    a: 'Yes. Every link is placed manually on a real, editorially relevant website using white-hat outreach — the same process a genuine PR or content team would use. We never use PBNs, link farms, spun content, or automated submission tools, so there is no link-scheme risk to your site.',
  },
  {
    q: 'How do you choose which websites to place links on?',
    a: 'Our outreach team evaluates each prospective site for Domain Authority (DA), Domain Rating (DR), organic traffic, topical relevance to your niche, and editorial quality before ever reaching out. Only sites that pass this review are used for placements.',
  },
  {
    q: 'How long does delivery take?',
    a: 'Starter packages typically deliver in 10–14 days, Growth packages in 14–18 days, and Authority packages in 18–25 days. Manual outreach takes longer than automated tools, but it\u2019s what keeps the links safe and effective.',
  },
  {
    q: 'What information do you need from me to get started?',
    a: 'Just your target URL (the page you want to rank), your target keywords or preferred anchor text, and any niche preferences. You provide this once at checkout — we don\u2019t ask for your account details again after you\u2019ve registered.',
  },
  {
    q: 'Will I get a report showing exactly what was delivered?',
    a: 'Yes. Every order includes a detailed report with the live URL, anchor text used, and authority metrics (DA/DR) for each backlink, viewable anytime from your account\u2019s Orders page.',
  },
  {
    q: 'Do you offer guest posts as well as backlinks?',
    a: 'Yes — our Growth and Authority tiers include a set number of guest posts on real, relevant blogs in addition to standard link placements. Custom guest-posting campaigns are also available on request.',
  },
  {
    q: 'What if a backlink gets removed after delivery?',
    a: 'We stand behind every placement. If a link is removed by the publisher within our guarantee window, we\u2019ll replace it with an equivalent or better placement at no extra cost.',
  },
  {
    q: 'How much do backlink packages cost?',
    a: 'Our packages start at ₹6,999 for the Starter Tier and go up to ₹32,999 for the Authority Tier, depending on link volume and authority level. Custom, higher-volume campaigns are available on request.',
  },
];

const VpsFaq = () => {
  const [expanded, setExpanded] = useState(0);

  return (
    <Section id="faq" sx={{ background: C.bgSection, borderBottom: `1px solid ${C.border}` }}>
      <Container maxWidth="lg">

        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <SectionLabel>FAQ</SectionLabel>
          <Typography variant="h2" sx={{
            fontWeight: 800, fontSize: { xs: '1.85rem', md: '2.5rem' },
            color: C.textPrimary, letterSpacing: '-0.03em', mb: 1.5,
          }}>
            Backlink Service FAQs
          </Typography>
          <Typography sx={{ color: C.textSecondary, fontSize: '1rem', maxWidth: 600, mx: 'auto' }}>
            Got questions about how our link building works? Here are clear answers to help you decide.
          </Typography>
        </Box>

        {/* Accordions */}
        <Box sx={{ maxWidth: 880, mx: 'auto' }}>
          {faqs.map((faq, i) => (
            <Accordion key={i} expanded={expanded === i} onChange={() => setExpanded(expanded === i ? false : i)}
              elevation={0}
              sx={{
                background: '#FFFFFF',
                border: `1px solid ${expanded === i ? C.primary : C.border}`,
                borderRadius: '12px !important',
                mb: 1.5,
                '&:before': { display: 'none' },
                boxShadow: expanded === i ? '0 4px 12px rgba(37,99,235,0.08)' : 'none',
                transition: 'all 0.18s',
              }}>
              <AccordionSummary expandIcon={<ExpandMore sx={{ color: C.primary }} />} sx={{ px: 3, py: 1 }}>
                <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.98rem' }}>
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pb: 3, pt: 0 }}>
                <Typography sx={{ color: C.textSecondary, fontSize: '0.9rem', lineHeight: 1.7 }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

      </Container>
    </Section>
  );
};

export default VpsFaq;
